import React from 'react';

import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';
import type { SxProps, Theme } from '@mui/system';

const cardSize = {
  normal: {
    desktop: 236,
    mobile: '100%',
  },
  small: {
    desktop: 172,
    mobile: 146,
  },
} as const;

type ProductCardVariant = keyof typeof cardSize;

type ProductCardSkeletonProps = {
  isAuthenticated: boolean;
  sx?: SxProps<Theme>;
  productCardVariant?: ProductCardVariant;
};

const ProductCardSkeleton = ({
  isAuthenticated = false,
  sx = {},
  productCardVariant = 'normal',
}: ProductCardSkeletonProps) => {
  return (
    <Card
      data-testid="product-card-skeleton"
      sx={{
        width: {
          xs: cardSize[productCardVariant]?.mobile,
          sm: cardSize[productCardVariant]?.desktop,
        },
        ...sx,
      }}
    >
      {/* image */}
      <Skeleton
        variant="rectangular"
        sx={{
          height: {
            xs: '172px',
            sm: '236px',
          },
          width: '100%',
          transform: 'unset',
        }}
      />
      <Stack
        gap="8px"
        sx={{
          p: { xs: '10px 11px 12px 11px', sm: '14px' },
        }}
      >
        <Skeleton variant="rectangular" sx={{ height: '38px', width: '100%', transform: 'unset' }} />
        <Skeleton variant="rectangular" sx={{ height: '35px', width: '100%', transform: 'unset' }} />
        {isAuthenticated ? (
          <Stack flexDirection="row" justifyContent="space-between">
            <Skeleton variant="rectangular" sx={{ transform: 'unset', height: '36px', width: '80px' }} />
            <Skeleton variant="circular" sx={{ transform: 'unset', height: '36px', width: '36px' }} />
          </Stack>
        ) : (
          <Skeleton
            variant="rectangular"
            sx={{ transform: 'unset', height: { xs: '23px', sm: '32px' }, width: '100%' }}
          />
        )}
      </Stack>
    </Card>
  );
};

export default ProductCardSkeleton;
